export const COMPANY_EMAIL = 'hlbelectric@gmail.com';
export const COMPANY_PHONE_NUMBER = '(520) 637-4702';
